import { BareActionContext } from 'vuex-typex'
import { ConvoState } from '../state'
import { RootState } from '../..'
import convoStore from '../convo-store'
import setConvoQuery from './set-convo-query'

export default async function toggleCreatedByMe(context: BareActionContext<ConvoState, RootState>)
{
  const form = convoStore.state.convoSearchForm
  form.createdByUser = false
  form.createdByFollowing = false
  setConvoQuery(context)

  return
}
